import apiClient from './apiClient'


const getFiles = (tenant, projectId, fileTypeId) => {
  const params = {
    fileTypeId
  }

  return apiClient.get(`/${tenant}/File/${projectId}`, { params })
}

const getFileInfoByFileData = (tenant, fileData) => {
  return apiClient.get(`/${tenant}/File/${fileData.projectId}/${fileData.id}`)
}

const getRelations = (tenant, id) => {
  return apiClient.get(`/${tenant}/File/${id}/Relations`)
}

const uploadFile = (tenant, projectId, fileTypeId, file) => {
  const formData = new FormData()
  formData.append('file', file)

  const config = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data'
    }
  }

  return apiClient.post(`/${tenant}/File/${projectId}/${fileTypeId}`, formData, config)
}

const downloadFile = (tenant, projectId, fileId) => {
  const config = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data'
    },
    responseType: 'arraybuffer'
  }

  return apiClient.get(`/${tenant}/File/${projectId}/${fileId}`, config)
}

const updateFile = (tenant, projectId, fileId, file) => {
  return apiClient.put(`/${tenant}/File/${projectId}/${fileId}`, file)
}

const deleteFile = (tenant, projectId, fileId) => {
  return apiClient.delete(`/${tenant}/File/${projectId}/${fileId}`)
}


export default {
  getFiles,
  getFileInfoByFileData,
  getRelations,
  uploadFile,
  downloadFile,
  updateFile,
  deleteFile
}
